import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';

import { useAccount } from 'reservations/account/providers/AccountProvider';
import { getTheme } from 'reservations/brand/helpers/v1/theme';
import useBrandData from 'reservations/brand/hooks/useBrandData';

type MuiThemeProviderProps = {
  children?: React.ReactNode;
};

function MuiThemeProvider({ children }: MuiThemeProviderProps) {
  const { primary_color: primaryColor } = useAccount();
  const { hasFeature, styles, fonts } = useBrandData();

  const theme = getTheme(hasFeature, primaryColor, styles, fonts);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{ '.clover-footer': { display: 'none' } }} />
      {children}
    </ThemeProvider>
  );
}

export default MuiThemeProvider;
